import filter from './filter';

const INITIAL_HISTORY = {
	records: [],
	filter: filter(undefined,{type:"START"})
}

const sortRecords = (records,key) => {
	const fn = (a,b) => {
	  if (a[key] < b[key])
	    return -1;
	  if (a[key] > b[key])
	    return 1;
	  return 0;
	}
	return records.sort(fn);
}

const trimFloat = (f,n) => parseFloat(parseFloat(f).toFixed(n))

export default (state=INITIAL_HISTORY, action) => {
		
	let newState = {...state};

	switch(action.type){
		case "NEW_VEHICLE":
			return newState;

		case "ADD_FILLUP":
			let record = {
				date: new Date(action.date)*1,
				odometer: trimFloat(action.odometer,1)|| 0,
				unit_price: trimFloat(action.unit_price,3) || 0,
				units: trimFloat(action.units,3) || 0,
				octane: trimFloat(action.octane,0) || 87
			}
			record.sub_total = trimFloat(record.unit_price * record.units,2)
			newState.records = sortRecords([...newState.records,record], "odometer");
			return newState;

		case "SET_VISIBILITY_FILTER":
			newState.filter = filter(newState.filter, action)
			return newState;	


		default:
			return newState;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/history.js